import React from 'react';
import ReactDOM from 'react-dom';
import jquery from 'jquery';
import { IS_CORDOVA } from 'constants/constants';

window.React = React;
window.ReactDOM = ReactDOM;
window.jQuery = jquery;
window.jquery = jquery;
window.$ = jquery;

if (IS_CORDOVA) {
  const { facebookConnectPlugin } = window;
  if (facebookConnectPlugin) {
    if (facebookConnectPlugin.getDeferredApplink) {
      facebookConnectPlugin.getDeferredApplink();
    }
  }
}
